import React, { FunctionComponent } from 'react';
import { ISimpleTasks } from '../../../../../app/page/page-storage/meeting-tasks/meeting-tasks.types';
import { TaskDragDropContext } from '../../../common/drag-drop-contexts/TaskDragDropContext';
import { WidgetTasksList } from '../../../common/widgets/WidgetTasksList';
import { IGoalsProps } from './types';

export const Goals: FunctionComponent<IGoalsProps> = ({ userId, goals, adminIds, meetingId }) => {
  const userGoals = goals.hasOwnProperty(Number(userId))
    ? ((goals[Number(userId)] as unknown) as ISimpleTasks)
    : { active: [], done: [] };
  const isAdmin = adminIds.includes(userId);

  return (
    <TaskDragDropContext key={userId}>
      <WidgetTasksList
        activeIds={userGoals.active}
        doneIds={userGoals.done}
        type={'qi'}
        isAdmin={isAdmin}
        userId={userId}
        meetingId={meetingId}
      />
    </TaskDragDropContext>
  );
};
